module.exports = __webpack_public_path__ + "img/web-error.964e43bf.png";